/* opendesk.ch – Blogbeitrag (sections/od-article.liquid) */
(() => {
  const init = () => {
    const root = document.querySelector('[data-oda]');
    if (!root || root.dataset.odaInit) return;
    root.dataset.odaInit = '1';

    /* Lesefortschritt (Horizon scrollt auf Desktop in .page-wrapper) */
    const bar = root.querySelector('[data-oda-progress]');
    const main = root.querySelector('.oda-main');
    const wrapper = document.querySelector('.page-wrapper');
    const update = () => {
      const r = main.getBoundingClientRect();
      const total = r.height - window.innerHeight;
      const p = total > 0 ? Math.min(1, Math.max(0, -r.top / total)) : 0;
      bar.style.transform = `scaleX(${p})`;
    };
    [window, wrapper].forEach((el) => el && el.addEventListener('scroll', update, { passive: true }));
    update();

    /* Inhaltsverzeichnis: aktiven Abschnitt markieren, auf Mobile standardmässig zu */
    const toc = root.querySelector('.oda-toc');
    if (toc) {
      if (window.matchMedia('(max-width: 749px)').matches) toc.removeAttribute('open');
      const links = [...toc.querySelectorAll('a')];
      const map = new Map(links.map((a) => [decodeURIComponent(a.hash.slice(1)), a]));
      const io = new IntersectionObserver((entries) => {
        entries.forEach((e) => {
          if (e.isIntersecting) {
            links.forEach((l) => l.classList.remove('is-active'));
            const l = map.get(e.target.id);
            if (l) l.classList.add('is-active');
          }
        });
      }, { rootMargin: '0px 0px -70% 0px' });
      root.querySelectorAll('.oda-body h2[id]').forEach((h) => io.observe(h));
    }

    /* Teilen: Link kopieren + native Share-Funktion */
    root.querySelectorAll('[data-oda-copy]').forEach((btn) => {
      btn.addEventListener('click', async () => {
        try {
          await navigator.clipboard.writeText(btn.dataset.odaCopy);
          btn.classList.add('is-done');
          const lbl = btn.querySelector('[data-label]');
          if (lbl) { const t = lbl.textContent; lbl.textContent = 'Kopiert'; setTimeout(() => { lbl.textContent = t; btn.classList.remove('is-done'); }, 1800); }
        } catch (e) { window.prompt('Link kopieren:', btn.dataset.odaCopy); }
      });
    });
    root.querySelectorAll('[data-oda-native]').forEach((btn) => {
      if (!navigator.share) { btn.hidden = true; return; }
      btn.hidden = false;
      btn.addEventListener('click', () => navigator.share({ title: document.title, url: btn.dataset.odaNative }).catch(() => {}));
    });

    /* Vorher/Nachher */
    root.querySelectorAll('[data-oda-ba]').forEach((ba) => {
      const r = ba.querySelector('[data-oda-ba-range]');
      r.addEventListener('input', () => ba.style.setProperty('--pos', r.value + '%'));
    });

    /* Lightbox für Galerie und Bilder im Text */
    const dlg = root.querySelector('[data-oda-lightbox]');
    const dImg = dlg.querySelector('[data-oda-lightbox-img]');
    const dCap = dlg.querySelector('[data-oda-lightbox-cap]');
    const items = [...root.querySelectorAll('.oda-gallery a[data-full], .oda-body img')];
    let idx = 0;
    const src = (el) => el.dataset.full || (el.currentSrc || el.src).replace(/width=\d+/, 'width=2400');
    const show = (i) => {
      idx = (i + items.length) % items.length;
      const el = items[idx];
      const img = el.tagName === 'IMG' ? el : el.querySelector('img');
      dImg.src = src(el);
      dImg.alt = img ? img.alt : '';
      dCap.textContent = img && img.alt ? img.alt : '';
    };
    items.forEach((el, i) => {
      el.style.cursor = 'zoom-in';
      el.addEventListener('click', (ev) => { ev.preventDefault(); show(i); dlg.showModal(); });
    });
    dlg.querySelector('[data-oda-lightbox-close]').addEventListener('click', () => dlg.close());
    dlg.querySelector('[data-oda-lightbox-prev]').addEventListener('click', () => show(idx - 1));
    dlg.querySelector('[data-oda-lightbox-next]').addEventListener('click', () => show(idx + 1));
    dlg.addEventListener('click', (e) => { if (e.target === dlg) dlg.close(); });
    dlg.addEventListener('keydown', (e) => { if (e.key === 'ArrowLeft') show(idx - 1); if (e.key === 'ArrowRight') show(idx + 1); });
    if (items.length < 2) dlg.querySelectorAll('.oda-lightbox__nav').forEach((b) => (b.hidden = true));

    /* Tabellen im Text horizontal scrollbar machen */
    root.querySelectorAll('.oda-body table').forEach((t) => {
      if (t.parentElement.classList.contains('oda-table')) return;
      const w = document.createElement('div');
      w.className = 'oda-table';
      t.parentNode.insertBefore(w, t);
      w.appendChild(t);
    });
  };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init); else init();
  document.addEventListener('shopify:section:load', init);
})();
